<ng-container *ngIf="costTotal && costTotal > 0">
  <h2 class="govuk-heading-l govuk-heading-l--inverse">{{ 'COMMON.APPOINTMENT_FEES' | translate }}</h2>
  <hr>

  <table class="govuk-table govuk-table--small-text-until-tablet" *ngIf="dataStore.serviceFees">
    <thead class="govuk-table__head">
      <tr class="govuk-table__row">
        <th scope="col" class="govuk-table__header">Items</th>
        <th scope="col" class="govuk-table__header">Amount</th>
        <th scope="col" class="govuk-table__header">Total</th>
        <ng-container *ngIf="daysAway > 182">
          <th scope="col" class="govuk-table__header">Deposit</th>
        </ng-container>
      </tr>
    </thead>
    <tbody class="govuk-table__body">
      <!-- <tr class="govuk-table__row">
                <th scope="row" class="govuk-table__header">{{service.name}}</th>
                <td class="govuk-table__cell">1</td>
                <td class="govuk-table__cell">{{dataStore.serviceFees.full_fee | currency:'GBP':'symbol':'1.2-2'}}</td>
                <td class="govuk-table__cell">{{dataStore.serviceFees.deposit | currency:'GBP':'symbol':'1.2-2'}}</td>
            </tr> -->
      <ng-container *ngFor="let fee of dataStore.serviceFees">
        <tr class="govuk-table__row" *ngIf="fee.cost * fee.quantity > 0">
          <th scope="row" class="govuk-table__header">{{ fee.item }}</th>
          <td class="govuk-table__cell">{{ fee.quantity }}</td>
          <td class="govuk-table__cell">
            {{ fee.cost * fee.quantity | currency : 'GBP' : 'symbol' : '1.2-2' }}
          </td>
          <ng-container *ngIf="daysAway > 182">
            <td class="govuk-table__cell">
              {{ fee.deposit * fee.quantity | currency : 'GBP' : 'symbol' : '1.2-2' }}
            </td>
          </ng-container>
        </tr>
      </ng-container>

      <tr class="govuk-table__row">
        <td class="govuk-table__header">Total</td>
        <td class="govuk-table__header">&nbsp;</td>
        <td class="govuk-table__header">
          {{ costTotal | currency : 'GBP' : 'symbol' : '1.2-2' }}
        </td>
        <ng-container *ngIf="daysAway > 182">
          <td class="govuk-table__header">
            {{ depositTotal | currency : 'GBP' : 'symbol' : '1.2-2' }}
          </td>
        </ng-container>
      </tr>
    </tbody>
  </table>
  <p class="govuk-body" *ngIf="!dataStore.serviceFees">Calculating fees</p>

  <!-- <div class="govuk-form-group">
        <fieldset class="govuk-fieldset" aria-describedby="payable_today">
            <legend class="govuk-fieldset__legend govuk-fieldset__legend--m">
                <h1 class="govuk-heading-l govuk-heading-l--inverse">
                    {{'COMMON.PAYABLE_TODAY' | translate}}
                </h1>
            </legend>

            <div class="govuk-hint">
                In order to confirm your booking, we will need to take a payment of <b>{{totalCost |
                    currency:'GBP':true}}</b> today by credit or debit
                card. We are not able to hold bookings without payment and your booking will be cancelled if payment
                cannot be taken. Payment will be taken in the next step.
            </div>
        </fieldset>
    </div> -->
</ng-container>
